import bar from 'daisy-chart/src/layouts/bar';
import data from './data/university.json';

bar().data(data)
  .name('bar')
  .container('#daisy-example')
  .dimensions(['지역'])
  .measures(['갯수'])
  .axis('x')
  .render();


// WEBPACK FOOTER //
// ./js/examples/monoBar.js